import {
  bus
} from '../../main';
var $ = window.jQuery = require('jquery');
import Vue from 'vue'
export default {
  name: 'quiz-instruction',
  components: {},
  props: [],
  data() {
    return {
      quizType: '',
      quizTitle: ''
    }
  },
  computed: {

  },
  mounted() {
    this.quizType = this.$route.params.slug;
    if (this.quizType == 'space-science') {
      this.quizTitle = 'space Science'
    } else if (this.quizType == 'ai-and-machine-learning') {
      this.quizTitle = 'Machine Learning';
    } else if (this.quizType == 'finance') {
      this.quizTitle = 'Finance';
    } else if (this.quizType == 'computational-sciences') {
      this.quizTitle = 'Computational Sciences';
    } else if (this.quizType == 'computer-science') {
      this.quizTitle = 'computer science';
    }
  },
  methods: {
    startQuiz() {
      this.QuizGameSHowFinance();
    },
    QuizGameSHow() {
      $('.quizzort_popup_wrp').removeClass('popup_slide_active')
      setTimeout(() => {
        bus.$emit('showQuizInstruction', false);
      }, 500);
      bus.$emit('showQuizGameSpace', true);
      setTimeout(() => {
        $('.quizzort_popup_wrp').addClass('popup_slide_active')
      }, 500);
    },
    QuizGameSHowCs() {
      $('.quizzort_popup_wrp').removeClass('popup_slide_active')
      setTimeout(() => {
        bus.$emit('showQuizInstruction', false);
      }, 500);
      bus.$emit('showQuizGameCS', true);
      setTimeout(() => {
        $('.quizzort_popup_wrp').addClass('popup_slide_active')
      }, 500);
    },
    QuizGameSHowFinance() {
      $('.quizzort_popup_wrp').removeClass('popup_slide_active')
      setTimeout(() => {
        bus.$emit('showQuizInstruction', false);
      }, 500);
      bus.$emit('showQuizGameFinance', true);
      setTimeout(() => {
        $('.quizzort_popup_wrp').addClass('popup_slide_active')
      }, 500);
    },
    QuizGameSHowMachineL() {
      $('.quizzort_popup_wrp').removeClass('popup_slide_active')
      setTimeout(() => {
        bus.$emit('showQuizInstruction', false);
      }, 500);
      bus.$emit('showQuizGameMachineLearning', true);
      setTimeout(() => {
        $('.quizzort_popup_wrp').addClass('popup_slide_active')
      }, 500);
    },
    QuizGameSHowComputationalS() {
      $('.quizzort_popup_wrp').removeClass('popup_slide_active')
      setTimeout(() => {
        bus.$emit('showQuizInstruction', false);
      }, 500);
      bus.$emit('showQuizGameComputationalS', true);
      setTimeout(() => {
        $('.quizzort_popup_wrp').addClass('popup_slide_active')
      }, 500);
    },
    showCategory() {
      $('.quizzort_main_wrp').removeClass('popup_active')
      setTimeout(() => {
        bus.$emit('showQuizInstruction', false);
        bus.$emit('hideQuizzortPopupEnabled', false);
        $("body").removeClass("quizzort_popup_active");
      }, 500)
      localStorage.setItem('Explore_Course', 'second_banner');
      this.$router.push('/')
    },
    QuizGamePopupClose() {
      $('.quizzort_main_wrp').removeClass('popup_active')
      setTimeout(() => {
        bus.$emit('showQuizInstruction', false);
        bus.$emit('hideQuizzortPopupEnabled', false);
        $("body").removeClass("quizzort_popup_active");
      }, 500)
    },
  },

}